import { InternalAxiosRequestConfig } from 'axios';
import { propagation, context } from '@opentelemetry/api';

/**
 * Adds the "traceparent" header to outgoing Axios requests to allow trace to
 * propagate to services outside the request initiator.
 *
 * @param config InternalAxiosRequestConfig
 * @returns InternalAxiosRequestConfig with the "traceparent" header added
 */
export const otelTraceParentRequestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const carrier = {};
  propagation.inject(context.active(), carrier);

  Object.entries(carrier).forEach(([key, value]) => {
    config.headers[key] = value;
  });

  return config;
};
